var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFC85E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_5050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3531 16.7125L17.0531 16.0125C17.1474 15.9194 17.2667 15.8557 17.3965 15.829C17.5263 15.8024 17.6611 15.814 17.7844 15.8625L18.6375 16.2031C18.7621 16.2537 18.869 16.3401 18.9446 16.4513C19.0203 16.5625 19.0613 16.6936 19.0625 16.8281V18.3906C19.0618 18.4821 19.0426 18.5725 19.006 18.6564C18.9694 18.7403 18.9162 18.8159 18.8496 18.8786C18.7831 18.9414 18.7045 18.9901 18.6186 19.0217C18.5328 19.0533 18.4414 19.0672 18.35 19.0625C12.3719 18.6906 11.1656 13.6281 10.9375 11.6906C10.9269 11.5955 10.9366 11.4992 10.9659 11.408C10.9952 11.3169 11.0435 11.233 11.1075 11.1619C11.1716 11.0907 11.25 11.034 11.3376 10.9953C11.4251 10.9566 11.5199 10.9369 11.6156 10.9375H13.125C13.2597 10.9379 13.3912 10.9786 13.5026 11.0543C13.614 11.1301 13.7001 11.2374 13.75 11.3625L14.0906 12.2156C14.1407 12.3385 14.1535 12.4733 14.1274 12.6034C14.1012 12.7334 14.0374 12.8529 13.9438 12.9469L13.2438 13.6469C13.2438 13.6469 13.6469 16.375 16.3531 16.7125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_5050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c49392ca5fdeac4295c87acadd93f299.svg";
export { ForwardRef as ReactComponent };